import React from "react";
import { useTranslate } from "src/locales";
import ByzAsynchronousSelectV2 from "src/components/core-components/ByzAsynchronousSelectV2";
import { McParameterDetailResponseDto } from "src/api/references/referenceServicesDtos";
import { SxProps, Theme, CircularProgress, Box } from "@mui/material";

interface ByzMcParameterDetailSelectProps {
  mcpId?: number;
  handleChange: (
    value:
      | McParameterDetailResponseDto
      | McParameterDetailResponseDto[]
      | null
  ) => void;
  multiple?: boolean;
  value?:
  | McParameterDetailResponseDto
  | McParameterDetailResponseDto[]
  | null;
  sx?: SxProps<Theme>;
  title?: string;
  title2?: string;
  cachedData?: McParameterDetailResponseDto[];
  cacheLoaded?: boolean;
  readOnly?: boolean;
}

export default function ByzMcParameterDetailSelect({
  mcpId,
  handleChange,
  multiple = false,
  value,
  title,
  title2,
  sx,
  cachedData,
  cacheLoaded = false,
  readOnly,
}: ByzMcParameterDetailSelectProps) {
  const { t } = useTranslate();

  if (!mcpId || mcpId <= 0) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "56px", ...sx }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!cacheLoaded) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '56px', ...sx }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  const handleChangeWrapper = (
    val: McParameterDetailResponseDto | McParameterDetailResponseDto[] | null | undefined
  ) => {
    if (val === null || val === undefined) {
      handleChange(null);
    } else if (multiple) {
      handleChange(val as McParameterDetailResponseDto[]);
    } else {
      if (Array.isArray(val)) {
        handleChange(val[0] || null);
      } else {
        handleChange(val as McParameterDetailResponseDto);
      }
    }
  };

  return (
    <ByzAsynchronousSelectV2<McParameterDetailResponseDto>
      preLoadedOptions={cachedData || []}
      label={t(title2 ?? "select")}
      onChange={handleChangeWrapper}
      value={value}
      selectLabel="name"
      multiple={multiple}
      sx={sx}
      disabled={readOnly}
    />
  );
}
